import React, { useMemo } from 'react';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import GridElementGenerator from './components/Generator/GridElementGenerator';
import { Button, Stack } from '@mui/material';
import { GridValueNormlizer } from './components/functions/GridValueNormlizer';
import { GridUiDataFormatter } from './components/functions/GridUiDataFormatter';
import GridUiList from './components/GridUiList/GridUiList';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { useContext } from 'react';
import ComponentMemoizer from 'Global/Components/ComponentMemoizer/ComponentMemoizer';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const EditableDataGridView = ({
  Gridfields,
  onChange,
  InitialData,
}) => {
  const [UiListIndex, setUiListIndex] =
    React.useState(null);
  const GlobalConstants = useContext(GlobalContext);
  const [RadioButton, setRadioButton] = React.useState();
  const GridDefaultValues = useMemo(
    () =>
      GridValueNormlizer({
        GroupElements: Gridfields,
      }),
    [Gridfields]
  );
  const { fields, control, formState, getValues, reset } =
    useCreateComplexField(
      `GridDefaultValues`,
      GridDefaultValues
    );
  const [GridList, setGridList] = React.useState([]);
  React.useEffect(() => {
    if (!UiListIndex) {
      reset({ GridDefaultValues });
      setRadioButton();
    }

    if (GridList.length > 0) {
      // onChange(GridList);
    }
  }, [GridList, UiListIndex]);
  React.useEffect(() => {
    if (InitialData?.length > 0) {
      setGridList(InitialData);
    }
  }, [InitialData]);
  React.useEffect(() => {
    if (UiListIndex) {
      const index = UiListIndex.findIndex((element) =>
        element.hasOwnProperty('index')
      );
      const newArr = [...GridList];
      newArr.splice(UiListIndex[index].index, 1);
      setGridList(newArr);
    }
  }, [UiListIndex]);

  return (
    <React.Fragment>
      <Stack gap=".5em">
        <ComponentMemoizer
          element={
            GridList.length > 0 ? (
              GridList.map((list, index) => (
                <GridUiList
                  UiData={list}
                  GridList={GridList}
                  setGridList={setGridList}
                  index={index}
                  key={GlobalConstants.uuidV4()}
                  onChange={onChange}
                  setUiListIndex={setUiListIndex}
                />
              ))
            ) : (
              <></>
            )
          }
          dependecies={[GridList, onChange]}
        />
      </Stack>
      <br />
      <Stack gap="0.5em">
        {(!UiListIndex ? fields : UiListIndex)?.map(
          (field, index) => (
            <SingleReactHookFormWrapper
              control={control}
              errors={formState.errors}
              element={
                <GridElementGenerator
                  element={field?.element}
                  key={field.id}
                  RadioButton={RadioButton}
                  setRadioButton={setRadioButton}
                  EditValue={
                    !UiListIndex ? null : field.value
                  }
                  field={field}
                />
              }
              name={`GridDefaultValues[${index}].value`}
              key={index}
            />
          )
        )}
        <Button
          sx={{
            color: `${themeColors.ColorPrimary} !important`,
          }}
          fullWidth
          variant="contained"
          color="colorPrimer"
          onClick={() => {
            if (!UiListIndex) {
              GridUiDataFormatter(getValues, setGridList);
            } else {
              GridUiDataFormatter(getValues, setGridList);
              reset({ GridDefaultValues });
              setRadioButton();
              setUiListIndex(null);
            }
          }}
        >
          {!UiListIndex ? 'افزودن' : 'ویرایش'}
        </Button>
      </Stack>
    </React.Fragment>
  );
};

export default EditableDataGridView;
